import React from 'react';
import styled from 'styled-components';
import { TextLink } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_600 } from '@oneaudi/unified-web-common';
import { useContent } from '../context/ContentContext';
import { useUniversalState } from '../context/UniversalStateContext';
import { useTrackingManager } from '../hooks/useTrackingManager';

export const VtpLinks = () => {
  const { stockCarsLink, preownedCarsLink } = useContent();
  const {
    translations: { filterNewcarsLink, filterUsedcarsLink },
  } = useUniversalState();
  const { clickVtpLink } = useTrackingManager();

  const handleClick = (type: string, linkText: string, url: string) => {
    const label = `model selector - click on '${type}' in left navigation`;
    clickVtpLink(label, linkText, url);
  };

  return (
    <VtpLinksWrapper>
      {stockCarsLink && (
        <VtpLink
          variant="standalone"
          size="sm"
          href={stockCarsLink}
          onClick={() => handleClick('new cars', filterNewcarsLink, stockCarsLink)}
        >
          {filterNewcarsLink}
        </VtpLink>
      )}
      {preownedCarsLink && (
        <VtpLink
          variant="standalone"
          size="sm"
          href={preownedCarsLink}
          onClick={() => handleClick('used cars', filterUsedcarsLink, preownedCarsLink)}
        >
          {filterUsedcarsLink}
        </VtpLink>
      )}
    </VtpLinksWrapper>
  );
};

const VtpLinksWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: grid;
    padding-top: ${SYS_SPACE_FIXED_600};

    border-top: ${({ theme }) =>
      theme.type === 'legacy' ? `1px solid ${theme.colors.dividerBgColor}` : 'none'};

    margin-top: ${({ theme }) => (theme.type === 'legacy' ? SYS_SPACE_FIXED_600 : '0')};
  }
`;

const VtpLink = styled(TextLink)`
  &:first-of-type {
    padding-bottom: ${SYS_SPACE_FIXED_200};
  }
`;
